import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.search.results;

const getSearchResults = createSelector(getData, results => results);

export default getSearchResults;



// WEBPACK FOOTER //
// ./src/_selectors/searchSelectors/getSearchResults.js